<section class="guest">

  <div class="guest__bar">
    <a href="#" class="guest__back" data-action="back">
      <i class="icon icon--arrow-left"></i> <%= _lcs( 'Alle Gästekonten' ) %>
    </a>
  </div>

  <!-- The account: name, address, status, roles. -->
  <div class="widget guest__profile">
    <div class="guest__person">
      <span class="guest__avatar"><%= guest.initials %></span>
      <div class="guest__who">
        <h2 class="guest__name"><%= guest.name %> <%- guest.statusHtml %></h2>
        <a class="guest__mail" href="mailto:<%= guest.email %>"><i class="icon icon--mail"></i> <%= guest.email %></a>
        <% if ( guest.status === 'not_validated' ) { %>
          <span class="guest__verify">
            <button type="button" class="btn btn--primary btn--sm" data-action="verify">
              <i class="icon icon--circle-check"></i> <%= _lcs( 'Manuell verifizieren' ) %>
            </button>
          </span>
        <% } %>
      </div>
    </div>
    <dl class="guest__facts">
      <div><dt><%= _lcs( 'Registriert' ) %></dt><dd><%= guest.registered %></dd></div>
      <div>
        <dt><%= _lcs( 'Rollen' ) %></dt>
        <dd class="role-badges">
          <% guest.roles.forEach( function( r ) { %>
            <span class="role-badge role-badge--<%= [ 'admin', 'client', 'guest' ].indexOf( r ) >= 0 ? r : 'other' %>"><%= r === 'guest' ? _lcs( 'Gast' ) : ( r === 'client' ? _lcs( 'Client' ) : ( r === 'admin' ? _lcs( 'Admin' ) : r ) ) %></span>
          <% } ); %>
        </dd>
      </div>
      <div><dt><%= _lcs( 'Konto-ID' ) %></dt><dd class="guest__id"><%= guest.id %></dd></div>
    </dl>
  </div>

  <div class="guests__stats">
    <div class="guests__stat">
      <span class="guests__stat-icon"><i class="icon icon--building-2"></i></span>
      <span class="guests__stat-text">
        <span class="guests__stat-value"><%= stats.houses %></span>
        <span class="guests__stat-label"><%= _lcs( 'Unterkünfte' ) %></span>
      </span>
    </div>
    <div class="guests__stat">
      <span class="guests__stat-icon"><i class="icon icon--message-circle"></i></span>
      <span class="guests__stat-text">
        <span class="guests__stat-value"><%= stats.messages %></span>
        <span class="guests__stat-label"><%= _lcs( 'Nachrichten vom Gast' ) %></span>
      </span>
    </div>
    <div class="guests__stat">
      <span class="guests__stat-icon"><i class="icon icon--calendar-days"></i></span>
      <span class="guests__stat-text">
        <span class="guests__stat-value"><%= stats.plans %></span>
        <span class="guests__stat-label"><%= _lcs( 'Pläne im Planer' ) %></span>
      </span>
    </div>
    <div class="guests__stat">
      <span class="guests__stat-icon"><i class="icon icon--clipboard-list"></i></span>
      <span class="guests__stat-text">
        <span class="guests__stat-value"><%= stats.surveys %></span>
        <span class="guests__stat-label"><%= _lcs( 'Umfrage-Einladungen' ) %></span>
      </span>
    </div>
  </div>

  <div class="guest__cols">

    <div class="guest__main">
      <!-- One read-only thread per house the guest wrote to. -->
      <% if ( chats.length === 0 ) { %>
        <div class="widget">
          <div class="widget__head">
            <h3 class="widget__title"><i class="icon icon--message-circle"></i> <%= _lcs( 'Chat-Verlauf' ) %></h3>
          </div>
          <p class="guest__empty"><%= _lcs( 'Dieser Gast hat noch mit keiner Unterkunft gechattet.' ) %></p>
        </div>
      <% } %>
      <% chats.forEach( function( c ) { %>
        <div class="widget guest__chat">
          <div class="widget__head">
            <h3 class="widget__title"><i class="icon icon--message-circle"></i> <%= _lcs( 'Chat mit {house}', { house: c.house } ) %></h3>
            <% if ( c.unread > 0 ) { %><span class="pill pill--warn"><%= _lcs( '{count} ungelesen', { count: c.unread } ) %></span><% } %>
          </div>
          <% if ( c.lines.length === 0 ) { %>
            <p class="guest__empty"><%= _lcs( 'Noch keine Nachrichten.' ) %></p>
          <% } else { %>
            <div class="gchat" data-id="chat-scroll">
              <% c.lines.forEach( function( l ) { %>
                <% if ( l.type === 'day' || l.type === 'sys' ) { %>
                  <div class="gchat__day<%= l.type === 'sys' ? ' gchat__day--sys' : '' %>"><%= l.text %></div>
                <% } else { %>
                  <div class="gchat__line gchat__line--<%= l.from %>">
                    <div class="gchat__bubble gchat__bubble--<%= l.from %><%= l.isConcierge ? ' gchat__bubble--ai' : '' %>">
                      <% if ( l.isConcierge ) { %><span class="gchat__ai"><%= _lcs( 'KI-Concierge' ) %></span><% } %>
                      <span class="gchat__text"><%= l.text %></span>
                      <span class="gchat__time"><%= l.time %></span>
                    </div>
                  </div>
                <% } %>
              <% } ); %>
            </div>
          <% } %>
        </div>
      <% } ); %>
    </div>

    <div class="guest__side">

      <div class="widget">
        <div class="widget__head">
          <h3 class="widget__title"><i class="icon icon--building-2"></i> <%= _lcs( 'Unterkünfte' ) %></h3>
        </div>
        <% if ( houses.length === 0 ) { %>
          <p class="guest__empty"><%= _lcs( 'Noch in keiner Unterkunft angemeldet.' ) %></p>
        <% } else { %>
          <ul class="guest__list">
            <% houses.forEach( function( h ) { %>
              <li class="guest__item">
                <span class="guest__item-main">
                  <span class="guest__item-title"><%= h.name %></span>
                  <span class="guest__item-sub"><%= _lcs( 'Erstmals {first} · zuletzt {last}', { first: h.firstSeen, last: h.lastSeen } ) %></span>
                </span>
              </li>
            <% } ); %>
          </ul>
        <% } %>
      </div>

      <div class="widget">
        <div class="widget__head">
          <h3 class="widget__title"><i class="icon icon--calendar-days"></i> <%= _lcs( 'Aufenthalte (Planer)' ) %></h3>
        </div>
        <% if ( plans.length === 0 ) { %>
          <p class="guest__empty"><%= _lcs( 'Noch keinen Aufenthalt im Planer angelegt.' ) %></p>
        <% } else { %>
          <ul class="guest__list">
            <% plans.forEach( function( p ) { %>
              <li class="guest__item">
                <span class="guest__item-main">
                  <span class="guest__item-title"><%= p.name %></span>
                  <span class="guest__item-sub"><%= p.house %> · <%= p.stay %></span>
                </span>
                <span class="guest__item-meta"><%= _lcs( '{count} Einträge', { count: p.itemCount } ) %></span>
              </li>
            <% } ); %>
          </ul>
        <% } %>
      </div>

      <div class="widget">
        <div class="widget__head">
          <h3 class="widget__title"><i class="icon icon--star"></i> <%= _lcs( 'Umfragen & Bewertungen' ) %></h3>
        </div>
        <% if ( surveys.length === 0 ) { %>
          <p class="guest__empty"><%= _lcs( 'Keine Umfrage-Einladungen.' ) %></p>
        <% } else { %>
          <ul class="guest__list">
            <% surveys.forEach( function( s ) { %>
              <li class="guest__item">
                <span class="guest__item-main">
                  <span class="guest__item-title"><%= s.title %></span>
                  <span class="guest__item-sub"><%= s.house %> · <%= s.channel %> · <%= s.sent %></span>
                </span>
                <% if ( s.state === 'completed' ) { %>
                  <span class="pill pill--ok"><%= _lcs( 'Abgeschlossen' ) %></span>
                <% } else if ( s.state === 'opened' ) { %>
                  <span class="pill pill--warn"><%= _lcs( 'Geöffnet' ) %></span>
                <% } else { %>
                  <span class="pill pill--neutral"><%= _lcs( 'Gesendet' ) %></span>
                <% } %>
              </li>
            <% } ); %>
          </ul>
        <% } %>
        <p class="guest__note">
          <i class="icon icon--shield-check"></i>
          <%= _lcs( 'Antworten werden nicht pro Gast angezeigt: Die Gäste-App sichert zu, dass Bewertungen für den Gastgeber anonym sind.' ) %>
        </p>
      </div>

    </div>
  </div>

</section>
